import React from 'react'

import { Box } from "@mui/material"
import { AppButtonIcon } from "@components"
import { isEditLoading, tableData, tableFormsData } from "Pages/Admin/OfficeMapping/@signals"
import { LoadingIconSeeker } from "@ui-seeker/core"


export default function actionsColumn(onSubmit) {

	return {
		name: 'name',
		label: 'Actions',
		options: {
			filter: false,
			sort: false,
			headerAlign: 'center',
			customBodyRowRenderLite: (_, row, rowIndex) => <ActionsCell rowIndex={rowIndex} row={row} onSubmit={onSubmit}/>
		}
	}
}

function ActionsCell({ row, rowIndex, onSubmit }) {
	const areObjectsEqual = (obj1 = {}, obj2 = {}) => {
		const keys1 = Object.keys(obj1).sort()
		const keys2 = Object.keys(obj2).sort()

		return keys1.length === keys2.length &&
			keys1.every(key => obj1[key] === obj2[key])
	}
	const isButtonDisabled = (
		tableData.value[rowIndex] &&
		areObjectsEqual(tableFormsData.value[rowIndex], tableData.value[rowIndex].fieldData)
	) || isEditLoading.value === rowIndex

	return (
		<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
			{isEditLoading.value === rowIndex ? (
				<LoadingIconSeeker/>
			) : (
				<AppButtonIcon
					icon="edit"
					iconWeight="solid"
					disabled={isButtonDisabled}
					tooltip="Edit and save mapping"
					sx={{ color: "warning.main" }}
					onClick={() => {
						onSubmit(rowIndex, row)
						tableData.value[rowIndex] = { ...row, fieldData: tableFormsData.value[rowIndex] }
					}}
				/>
			)}
		</Box>
	)
}
